<template>
  <div
    class="detail-box"
    :style="{ 'user-select': articleInfo.status ? 'text' : 'none' }"
  >
    <div class="detail-top">
      <el-button class="btn" @click="backPage">
        <el-icon color="#437ef5"><ArrowLeft /></el-icon>
        返回</el-button
      >
      <div class="time">
        当前期次：{{ dayjs(timeValue).format("YYYY-MM-DD") }}
        <span
          >&nbsp;&nbsp;&nbsp;&nbsp;

          <span style="display: inline-block; max-width: 50rem">
            {{ currentVersionName }}</span
          >
        </span>
      </div>
    </div>
    <div class="detail-container">
      <Loading :loading="loading" />
      <div class="detail-content">
        <div class="title">
          <div
            class="detail-subtitle"
            v-html="convertStylePxToRem(articleInfo?.articleVo?.pretitle)"
          ></div>
          <div
            class="detail-title"
            v-html="convertStylePxToRem(articleInfo?.articleVo?.title)"
          ></div>
          <div
            class="detail-subtitle"
            v-html="convertStylePxToRem(articleInfo?.articleVo?.subtitle)"
          ></div>
          <div
            class="detail-subtitle"
            v-html="convertStylePxToRem(articleInfo?.articleVo?.author)"
          ></div>
        </div>
        <div class="content" ref="scrollContainer">
          <div
            class="detail-pic"
            v-for="(item, index) in articleInfo?.articleVo?.picList"
            :key="index"
          >
            <img :src="item.url" />
            <p v-html="convertStylePxToRem(item.picText)"></p>
          </div>
          <div
            class="detail-text"
            v-html="convertStylePxToRem(articleInfo?.articleVo?.content)"
          ></div>
        </div>
      </div>
      <div class="prompt-section" v-show="!articleInfo.status">
        <div class="prompt">
          请扫描右侧小程序二维码进行订阅，展示全部内容
          <el-icon style="margin-left: 0.2rem; font-size: 1.3rem"
            ><Lock
          /></el-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, watchEffect, computed } from "vue";
import { code, siteId } from "@/services/config";
import Loading from "@/components/Loading/index.vue";
import dayjs from "dayjs";

const scrollContainer = ref(null); // 创建 ref 引用

const props = defineProps([
  "timeValue",
  "currentNewsId",
  "requestApi",
  "currentVersionName",
]);
const emit = defineEmits(["closeInfo"]);

const articleInfo = ref({}); //文章详情
const loading = ref(false); // 是否加载中

//返回主页面
const backPage = () => {
  emit("closeInfo");
};

//获取文章详情
const getArticleInfo = async () => {
  loading.value = true;
  const params = {
    code,
    id: props.currentNewsId,
    siteId,
  };
  const res = await props.requestApi.articleId(params);
  if (res.status == 200) {
    articleInfo.value = res.obj;
    loading.value = false;
    scrollContainer.value?.scrollTo({ top: 0, behavior: "smooth" });
  }
};

const convertStylePxToRem = (htmlString: string) => {
  // 匹配style属性中的px值
  return htmlString?.replace(/style="([^"]*)"/g, (match, styleContent) => {
    const convertedStyle = styleContent.replace(
      /(\d+)px/g,
      (_: any, pxValue: any) => {
        return parseInt(pxValue) / 10 + "rem";
      }
    );
    return 'style="' + convertedStyle + '"';
  });
};

watchEffect(() => {
  if (props.currentNewsId) {
    getArticleInfo();
  }
});
onMounted(() => {
  getArticleInfo();
});
</script>

<style scoped lang="scss">
div {
  box-sizing: border-box;
}
.detail-box {
  width: 100%;
  height: 100%;
  .detail-top {
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 100%;
    height: 3.2rem;
    .btn {
      display: flex;
      align-items: center;
      width: 8rem;
      height: 3.2rem;
      border-radius: 0.8rem;
      border: 0.1rem solid #0d59fa;
      opacity: 0.8;
      font-size: 1.4rem;
      color: #0d59fa;
    }
    .time {
      display: flex;
      align-items: center;
      font-size: 1.4rem;
      span {
        color: #646464;
      }
    }
  }
  .detail-container {
    position: relative;
    width: 100%;
    //height: 60.8rem;
    height: auto;
    margin-top: 1rem;
    padding: 2rem 2rem 2rem;
    background: #ffffff;
    border-radius: 1.2rem;
    .prompt-section {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      position: absolute;
      width: 100%;
      height: 100%;
      bottom: 0;
      left: 0;
      right: 0;
      mask-image: linear-gradient(to bottom, transparent 0%, black 100%);
      -webkit-mask-image: linear-gradient(
        to bottom,
        transparent 0%,
        rgb(0, 0, 0) 100%
      );
      background-color: #ffffff; /* 示例背景色 */
      padding: 2rem;
      box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.5); /* 可选阴影效果 */
      .prompt {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 3rem;
        font-size: 1.6rem;
        color: #009dff;
        background: #ffffff;
      }
    }
  }
  .detail-content {
    width: 100%;
    height: 100%;
    padding: 0rem 2.5rem;

    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: auto;
    }
    .content {
      width: 100%;
      height: 51.6rem;
      overflow-y: auto;
      /* 隐藏默认滚动条的外边框 */
      scrollbar-width: thin; /* Firefox 兼容 */
      scrollbar-color: #c1c1c1 transparent; /* Firefox 滑块颜色 */
      padding-right: 1rem;
    }
    .detail-title {
      width: 100%;
      min-height: 3rem;
      text-align: center;
      font-weight: 600;
      font-size: 2.3rem;
      color: #000000;
      font-family: "微软雅黑", "宋体";
    }
    .detail-subtitle {
      padding: 0.5rem 0;
      font-size: 1.4rem;
    }
    .detail-pic {
      margin-top: 1.8rem;
      font-size: 1.4rem;
    }
    .detail-abstract {
      width: 100%;
      height: 2.8rem;
      text-align: center;
      margin-top: 0.8rem;
      font-size: 2rem;
      color: #000000 !important;
    }
    .detail-text {
      width: 100%;
      height: auto;
      text-align: left;
      margin-top: 2rem;
      font-size: 1.4rem;
      line-height: 2.5rem;
    }
    :deep(p) {
      text-align: justify;
      margin: 0 !important;
      //text-indent: 1.2rem;
      color: #000000;
    }
  }
  .detail-content::-webkit-scrollbar {
    width: 0.1rem; /* 滚动条宽度（变细） */
    background: transparent; /* 滚动条轨道透明 */
  }
  .detail-content::-webkit-scrollbar-thumb {
    background: #c1c1c1; /* 滑块颜色 */
    border-radius: 0.1rem; /* 滑块圆角 */
  }
  .detail-content::-webkit-scrollbar-thumb:hover {
    background: #ffffff; /* 悬停时颜色 */
  }
}
</style>
